export { default } from "./ManyToManyModal";
